<script lang='ts'>
    import { Button, Icon } from "sveltestrap";
    import type { ThirdLicense } from "../Model/ThirdLicense";
    import ParamSelect from "./ParamSelect.svelte";
    import { thirdLicenseService } from "../services";
    import { createEventDispatcher } from "svelte";
    import { dateInputFormatter } from "../services/Functions";

    const dispatch = createEventDispatcher();

    export let license: ThirdLicense;
    export let removeButton: boolean;

    async function save() {
        let response = await thirdLicenseService.saveThirdLicense(license);

        if (response) {
            dispatch("addLicense", license);
            license = null;
        }
    }

    async function remove() {
        if (!confirm("¿Esta seguro de querer eliminar el parámetro?")) return;

        let response = await thirdLicenseService.removeThirdLicense(license.id, license.third_id);

        if (response) {
            dispatch("removeLicense", license);
            license = null;
        }
    }

    function changeDate(event: any) {
        let date = event.srcElement.value;
        license.exp_date = new Date(date).toISOString();
    }
</script>
{#if license}
    <div class='row p-4 border rounded-2'>
        <div class='col-12 text-end mb-3'>
            <button class='bg-transparent border border-white p-1' on:click={() => license = null}><Icon name='x-lg' /></button>
        </div>
        <div class='col-12'>
            <ParamSelect bind:paramSelectId={license.license_type} paramType='licenseType' nothing/>
        </div>
        

        <div class='col-12 mt-3'>
            <label for='exp_date' class='mb-2'>
                Fecha de validez
            </label>
            <input 
                class='form-control'
                type='date' 
                value={dateInputFormatter(license.exp_date)}
                on:change={(e) => changeDate(e)}
            />
        </div>
        <hr class='my-3'>
        <div class='col-12 text-end'>
            {#if removeButton}
                <Button color="danger" on:click={remove}>Eliminar</Button>
            {/if}
            <Button color="primary" on:click={save}>Guardar</Button>
        </div>
    </div>
{/if}